import { useTranslation } from "react-i18next";
import BarGraph from "./BarGraph";
import { determineAvg } from "../body-composition.helper";
import NoData from "./NoData";
import SvgIcon from "../../../../../parts/SvgIcon";

const Header = ({ date, athlete, organizationCoachParam }) => {
  const { t } = useTranslation("athlete-portal");
  return (
    <header>
      <div>
        <h4>{t("bodyComposition.steps.title")}</h4>
        <p className="p4">{t("bodyComposition.averageForWeek")}</p>
      </div>
      <a
        className="composition-see-more mobile-hidden"
        href={`/athlete-portal/metrics/step-count?date=${date}&athlete=${athlete}&bodycomp=true${organizationCoachParam}`}
      >
        <span>{t("bodyComposition.seeMore")}</span>
        <SvgIcon
          src="/img/new-icons/arrow-square-right-gradient.svg"
          noFilterOnLight={true}
        />
      </a>
    </header>
  );
};

const Results = ({
  data,
  avg,
  previousAverage,
  date,
  athlete,
  organizationCoachParam,
}) => {
  const { t } = useTranslation("athlete-portal");
  const increase = avg - previousAverage || 0;
  const percentage =
    Math.round(((avg - previousAverage) / previousAverage) * 100) || 0;
  const isPositivePercentage = increase >= 0;

  let hasData = false;
  data.forEach((d) => {
    if (d.steps) {
      hasData = true;
    }
  });
  return (
    <div>
      {hasData && (
        <div>
          <div>
            {!!previousAverage && (
              <span
                className={
                  isPositivePercentage ? "text-(--success)" : "text-(--danger)"
                }
              >
                <img
                  src={
                    isPositivePercentage
                      ? "/img/svg/green-up-icon.svg"
                      : "/img/svg/red-down-icon.svg"
                  }
                />{" "}
                {percentage}%
              </span>
            )}
            <div>
              <h1>{avg}</h1>
              <span className="composition-second-font">{t("bodyComposition.steps.label")}</span>
            </div>
          </div>
        </div>
      )}
      <div className="adherence-chart-new">
        <BarGraph
          data={data}
          graphId={"steps-graph"}
          targetValue={"steps"}
          average={avg}
        />
      </div>
    </div>
  );
};

const StepsStats = ({
  data,
  date,
  athlete,
  previousWeek,
  organizationCoachParam,
}) => {
  const { t } = useTranslation("athlete-portal");
  const average = determineAvg(data, "steps");
  const previousAverage = determineAvg(previousWeek, "steps");

  return (
    <article id="steps-data">
      <Header
        date={date}
        athlete={athlete}
        organizationCoachParam={organizationCoachParam}
      />
      {data.length ? (
        <Results
          date={date}
          athlete={athlete}
          organizationCoachParam={organizationCoachParam}
          data={data}
          avg={average}
          previousAverage={previousAverage}
        />
      ) : (
        <NoData />
      )}
      <footer className="only-show-mobile">
        <a
          className="composition-see-more"
          href={`/athlete-portal/metrics/step-count?date=${date}&athlete=${athlete}&bodycomp=true${organizationCoachParam}`}
        >
          <span>{t("bodyComposition.seeMore")}</span>
          <SvgIcon
            src="/img/new-icons/arrow-square-right-gradient.svg"
            noFilterOnLight={true}
          />
        </a>
      </footer>
    </article>
  );
};

export default StepsStats;
